/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/components/controlVariations/SearchableDropdown.module.css';
import arrow from '../../assets/profile/Vector (13).png';

interface Props {
	placeholder?: string;
	options: string[];
	selected?: string;
	onSelect: (value: string) => void;
	width?: string;
	height?: string | number;
	menuMaxHeight?: string | number;
}

const SearchableDropdown: React.FC<Props> = ({
	placeholder = 'Select',
	options,
	selected,
	onSelect,
	width = '100%',
	height = '58px',
	menuMaxHeight = '235px',
}) => {
	const [open, setOpen] = useState(false);
	const [search, setSearch] = useState('');
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handler = (e: MouseEvent) => {
			if (ref.current && !ref.current.contains(e.target as Node)) {
				setOpen(false);
				setSearch('');
			}
		};
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, []);

	const filtered = options.filter(opt =>
		opt.toLowerCase().includes(search.toLowerCase())
	);

	return (
		<div className={styles.wrapper} style={{ width }} ref={ref}>
			<div
				className={`${styles.dropdown} ${open ? styles.active : ''}`}
				style={{ height }}
				onClick={() => setOpen(!open)}
			>
				<span className={styles.text}>{selected || placeholder}</span>
				<img src={arrow} className={open ? styles.rotate : ''} />
			</div>

			{open && (
				<div
					className={styles.menu}
					style={{ maxHeight: menuMaxHeight }}
				>
					{/* SEARCH INPUT */}
					<input
						className={styles.search}
						placeholder="Type Here"
						value={search}
						onChange={e => setSearch(e.target.value)}
						autoFocus
					/>

					{/* LIST */}
					{filtered.map((opt, i) => (
						<div
							key={i}
							className={styles.menuItem}
							onClick={() => {
								onSelect(opt);
								setOpen(false);
								setSearch('');
							}}
						>
							{opt}
						</div>
					))}

					{filtered.length === 0 && (
						<div className={styles.noResult}>No results found</div>
					)}
				</div>
			)}
		</div>
	);
};

export default SearchableDropdown;
